<template>
  <div class="sidebar-wrapper" :class="isDark ? 'theme--dark' : 'theme--light'">

    <!-- Perfil do usuário -->
    <div class="user-section">
      <v-avatar size="42" class="user-avatar">
        <span class="user-initial">{{ userName.charAt(0) }}</span>
      </v-avatar>
      <div class="user-info">
        <div class="user-name text-truncate">{{ userName }}</div>
        <div class="user-email text-truncate">{{ userEmail }}</div>
      </div>
    </div>

    <div class="menu-divider"></div>

    <div class="menu-header">Navegação</div>

    <v-list
      v-model:opened="openedGroups"
      nav
      density="compact"
      class="menu-list"
    >
      <template v-for="(menu, index) in menus" :key="index">
        <!-- Item simples -->
        <v-list-item
          v-if="!menu.items"
          :value="menu.to"
          :to="menu.to"
          rounded="lg"
          class="mb-1 menu-item"
          active-color="white"
        >
          <template v-slot:prepend>
            <v-icon :icon="menu.icone" size="18" class="menu-icon"></v-icon>
          </template>
          <v-list-item-title class="menu-title">{{ menu.titulo }}</v-list-item-title>
        </v-list-item>

        <!-- Grupo com subitens -->
        <v-list-group
          v-else
          :value="menu.titulo"
          :class="['mb-1', { 'group-active': groupIsActive(menu) }]"
        >
          <template v-slot:activator="{ props }">
            <v-list-item v-bind="props" rounded="lg" class="menu-item">
              <template v-slot:prepend>
                <v-icon :icon="menu.icone" size="18" class="menu-icon"></v-icon>
              </template>
              <v-list-item-title class="menu-title">{{ menu.titulo }}</v-list-item-title>
            </v-list-item>
          </template>

          <v-list-item
            v-for="(submenu, idx) in menu.items"
            :key="idx"
            :to="submenu.to"
            :value="submenu.to"
            rounded="lg"
            class="submenu-item mb-1"
            active-color="white"
          >
            <template v-slot:prepend>
              <v-icon icon="mdi-circle-small" size="16" class="submenu-dot"></v-icon>
            </template>
            <v-list-item-title class="submenu-title">{{ submenu.titulo }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </template>
    </v-list>

    <div class="sidebar-footer">
      <span class="footer-version">v2.0.4 · AOM ADMIN</span>
    </div>
  </div>
</template>

<script>
import { PERMISSOES } from "@/util/permissoes";

export default {
  name: "BarraLateral",
  data() {
    return {
      openedGroups: [],
      menuItems: [
        { titulo: "Página inicial", icone: "mdi-home-variant-outline", to: "/home" },
        {
          titulo: "Seminário",
          icone: "mdi-school-outline",
          items: [
            { titulo: "Gestão de Quartos", to: "/seminario", permissao: PERMISSOES.GESTAO_QUARTOS },
            { titulo: "Inscrição no Retiro", to: "/inscricao-retiro", permissao: PERMISSOES.INSCRICAO_RETIRO },
            { titulo: "Inscrição Equipe de Trabalho", to: "/inscricao-retiro-equipe-trabalho", permissao: PERMISSOES.INSCRICAO_RETIRO_EQUIPE },
            { titulo: "Lista de Inscritos", to: "/listar-inscritos-retiro", permissao: PERMISSOES.LISTAR_INSCRITOS_RETIRO },
          ],
        },
        {
          titulo: "Cadastro",
          icone: "mdi-account-plus-outline",
          items: [
            { titulo: "Pagamentos", to: "/pagamento", permissao: PERMISSOES.CADASTRAR_PAGAMENTO },
            { titulo: "Pessoas", to: "/cadastro-pessoa", permissao: PERMISSOES.CADASTRAR_USUARIO },
            { titulo: "Medicamentos", to: "/cadastro-medicamento", permissao: PERMISSOES.CADASTRAR_MEDICAMENTO },
            { titulo: "Catálogo Med.", to: "/catalogo-medicamentos", permissao: PERMISSOES.CADASTRAR_CATALOGO_MEDICAMENTO },
            { titulo: "Permissões", to: "/gerenciar-permissoes", permissao: PERMISSOES.GERENCIAR_PERMISSOES },
          ],
        },
        {
          titulo: "Relatórios",
          icone: "mdi-chart-box-outline",
          items: [
            { titulo: "Lista de Pessoas", to: "/listar-pessoa", permissao: PERMISSOES.LISTAR_USUARIOS },
            { titulo: "Histórico Med.", to: "/listar-medicamento", permissao: PERMISSOES.LISTAR_MEDICAMENTOS },
          ],
        },
        {
          titulo: "Fila de Atendimento",
          icone: "mdi-human-queue",
          items: [
            { titulo: "Gerenciar Fila", to: "/fila-atendimentos", permissao: PERMISSOES.GERENCIAR_FILA },
            { titulo: "Painel de Senhas", to: "/painel-fila", permissao: PERMISSOES.PAINEL_FILA },
          ],
        },
        {
          titulo: "Ao vivo",
          icone: "mdi-broadcast",
          items: [
            { titulo: "X Reaja", to: "/xreaja" },
            { titulo: "Programação", to: "/programacao" },
          ],
        },
      ],
    };
  },
  computed: {
    isDark() {
      return this.$vuetify.theme.global.name === "dark";
    },
    userEmail() { return this.$store.state.user?.email || "email@provedor.com"; },
    userName() { return this.$store.state.user?.name || "Administrador"; },
    menus() {
      return this.menuItems
        .map((menu) => {
          if (!menu.items) return menu;
          const itensVisiveis = menu.items.filter((item) => this.temPermissao(item.permissao));
          return { ...menu, items: itensVisiveis };
        })
        .filter((menu) => !menu.items || menu.items.length > 0);
    },
  },
  mounted() { this.syncOpenedGroups(); },
  watch: {
    "$route.path"() { this.syncOpenedGroups(); },
  },
  methods: {
    temPermissao(permissao) {
      if (!permissao) return true;
      return this.$store.getters.hasPermission(permissao);
    },
    groupIsActive(menu) {
      return !!menu.items?.some((s) => this.$route.path === s.to);
    },
    syncOpenedGroups() {
      this.openedGroups = this.menus
        .filter((m) => this.groupIsActive(m))
        .map((m) => m.titulo);
    },
  },
};
</script>

<style scoped>
.sidebar-wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: transparent;
  color: #e2e8f0;
  overflow: hidden;
}

/* ── Perfil ── */
.user-section {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 16px 16px;
}

.user-avatar {
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  flex-shrink: 0;
}

.user-initial {
  color: #fff;
  font-weight: 700;
  font-size: 1.1rem;
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-name {
  font-size: 0.9rem;
  font-weight: 700;
  color: #f1f5f9;
  line-height: 1.3;
}

.user-email {
  font-size: 0.72rem;
  color: rgba(255, 255, 255, 0.5);
  max-width: 160px;
}

.menu-divider {
  height: 1px;
  background: rgba(255,255,255,0.07);
  margin: 0 16px 14px;
}

/* ── Cabeçalho do menu ── */
.menu-header {
  padding: 0 18px 8px;
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
}

/* ── Lista ── */
.menu-list {
  padding: 0 8px 12px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
}

/* ── Item principal ── */
.menu-item {
  color: rgba(255, 255, 255, 0.85) !important;
  border-radius: 10px !important;
  min-height: 44px;
  transition: background 0.15s, color 0.15s;
}

.menu-item:hover {
  background: rgba(255,255,255,0.06) !important;
  color: #e2e8f0 !important;
}

.menu-icon {
  color: rgba(255, 255, 255, 0.7) !important;
}

.menu-title {
  font-size: 0.88rem;
  font-weight: 500;
  font-family: 'Poppins', Roboto, sans-serif;
  letter-spacing: 0.01em;
}

/* ── Item ativo ── */
:deep(.v-list-item--active) {
  background: rgba(59, 130, 246, 0.18) !important;
  color: #93c5fd !important;
  border: 1px solid rgba(59,130,246,0.25) !important;
}

:deep(.v-list-item--active .v-icon),
:deep(.v-list-item--active .v-list-item-title) {
  color: #93c5fd !important;
}

/* ── Subitem ── */
.submenu-item {
  padding-left: 10px !important;
  min-height: 38px !important;
  border-radius: 8px !important;
  color: rgba(255, 255, 255, 0.65) !important;
}

.submenu-item:hover {
  background: rgba(255,255,255,0.05) !important;
  color: #cbd5e1 !important;
}

.submenu-dot {
  color: rgba(255, 255, 255, 0.4) !important;
}

.submenu-title {
  font-size: 0.83rem;
  color: inherit;
  white-space: normal;
  line-height: 1.25;
}

/* linha vertical no grupo ativo */
.group-active :deep(.v-list-group__items) {
  border-left: 2px solid rgba(59,130,246,0.35);
  margin-left: 16px;
  padding-left: 4px;
}

/* seta do grupo */
:deep(.v-list-group__header .v-list-item__append .v-icon) {
  color: rgba(255, 255, 255, 0.5) !important;
}

/* ── Rodapé ── */
.sidebar-footer {
  padding: 14px 18px;
  border-top: 1px solid rgba(255,255,255,0.07);
  text-align: center;
}

.footer-version {
  font-size: 0.68rem;
  color: rgba(255, 255, 255, 0.35);
  font-weight: 600;
  letter-spacing: 0.05em;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Modo claro ── */
.theme--light {
  color: #1e3a8a;
}

.theme--light .user-name {
  color: #1e3a8a;
}

.theme--light .user-email {
  color: #3b82f6;
}

.theme--light .menu-divider {
  background: rgba(30, 58, 138, 0.15);
}

.theme--light .menu-header {
  color: #3b82f6;
}

.theme--light .menu-item {
  color: #1e40af !important;
}

.theme--light .menu-item:hover {
  background: rgba(37, 99, 235, 0.12) !important;
  color: #1e3a8a !important;
}

.theme--light .menu-icon {
  color: #3b82f6 !important;
}

.theme--light :deep(.v-list-item--active) {
  background: rgba(37, 99, 235, 0.2) !important;
  color: #1e3a8a !important;
  border: 1px solid rgba(37, 99, 235, 0.35) !important;
}

.theme--light :deep(.v-list-item--active .v-icon),
.theme--light :deep(.v-list-item--active .v-list-item-title) {
  color: #1e3a8a !important;
}

.theme--light .submenu-item {
  color: #3b82f6 !important;
}

.theme--light .submenu-item:hover {
  background: rgba(37, 99, 235, 0.1) !important;
  color: #1e3a8a !important;
}

.theme--light .submenu-dot {
  color: #93c5fd !important;
}

.theme--light .group-active :deep(.v-list-group__items) {
  border-left: 2px solid rgba(37, 99, 235, 0.4);
}

.theme--light :deep(.v-list-group__header .v-list-item__append .v-icon) {
  color: #3b82f6 !important;
}

.theme--light .sidebar-footer {
  border-top: 1px solid rgba(30, 58, 138, 0.15);
}

.theme--light .footer-version {
  color: #3b82f6;
}
</style>
